// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2uHfM","signatureButtonsRight":"ModalSign_signatureButtonsRight__1A5kH"};